module.exports = __webpack_public_path__ + "img/AdventurersBG.27ceb4c5.jpg";